export default {
  text: 'Stiamo preparando il tuo tavolo 🍽…',
};
